module.exports = __webpack_public_path__ + "img/login-log.b502514d.png";